import { render, staticRenderFns } from "./ReconhecimentoFacialEmpresa.vue?vue&type=template&id=f4d703e8"
import script from "./ReconhecimentoFacialEmpresa.vue?vue&type=script&lang=js"
export * from "./ReconhecimentoFacialEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports